import React, { useState } from "react";
import styles from "./purchaseOrderDetailsCards.module.css";
import moment from "moment";

export const PurchaseOrderDetailsCard = ({
  id,
  delivery_date,
  date,
  po_display_number,
  title,
}) => {
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/basicDetails.svg" alt="" />
            </div>
            <h6>General Info</h6>
          </div>

          <img
            src="/images/upArrow.png"
            //className={!show && styles.rotateSvg}
            className={(!show) ? styles.rotateSvg : ""}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <>
            <div className={styles.basicInfoDetailPOCard}>
              <span>
                <p>PO NO</p>
                <p>{po_display_number ? po_display_number : "-"}</p>
              </span>

              <span>
                <p>PO TITLE</p>
                <p>{title ? title : "-"}</p>
              </span>
            </div>
            <div className={styles.basicInfoDetailPOCard}>
              <span>
                <p>PO DATE</p>
                <p>{moment(date).format("DD MMM YYYY")}</p>
              </span>
              {(delivery_date == "0000-00-00") ?
                ("") : (<span>
                  <p>DELIVERY DATE</p>
                  <p> {moment(delivery_date).format("DD MMM YYYY")}</p>
                </span>)
              }
            </div>
          </>
        )}
      </div>
    </div>
  );
};
